import React from 'react';
require('../../scss/style.scss');
import Login from '../containers/login';
import { BrowserRouter } from 'react-router-dom';
import {constants, KeolisSpinner, moment} from '../containers/common/commonExport';
import Sidebar from '../containers/common/sidebar';
import Header from '../containers/common/header'
import ScrollUpButton from "react-scroll-up-button"; //Add this line Here
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../actions/index";
import LoadingBar from 'react-redux-loading-bar';
import Notification from '../containers/common/Notification';
import PrintInProgress from './PrintInProgress';
import ActionInProgress from './ActionInProgress';
import CoverLoading from './CoverLoading';

class AdminTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSidebar:true
        }
    }
    toggleSidebar(){
        let showSidebar = this.state.showSidebar;
        this.setState({
            showSidebar:!showSidebar
        })
    }
    render(){
        let props = this.props,
            printStatus = this.props.printState.printStatus,
            coverStatus = this.props.coverLoadingState.coverStatus,
            showSidebar = this.state.showSidebar,
            actionInProcess = this.props.notificationState.actionInProcess;
        return (
            <div className={"fullHeight animated " + (showSidebar ? "showSidebar":"hideSidebar")}>
                <Notification />
                <ScrollUpButton
                    ContainerClassName='ScrollUpButton__Container'
                    TransitionClassName='ScrollUpButton__Toggled'>
                    <span className="upArrow"></span>
                </ScrollUpButton>
                <CoverLoading coverStatus={coverStatus} />
                <PrintInProgress printStatus={printStatus} />
                <ActionInProgress showActionInProgress={actionInProcess} />
                <div className="col-sm-2 sidebarContainer">
                    <Sidebar Admin={props.admin}/>
                </div>
                <div className="col-sm-10 mainBodyContainer">
                    <Header toggleSidebar = {() => this.toggleSidebar.bind(this)}/>
                    <header>
                        <LoadingBar className="loadingBar" style={{ backgroundColor: '#3462ae', height: '3px' }} />
                    </header>
                    <div className="mainBodySection animated fadeIn">
                        <div>
                            <div className="head-title"> {props.compTitle} </div>
                            
                            <button className={props.admin ? 'hidden' : "btn btn-primary pull-right"}
                            onClick={props.onRefresh}>Refresh</button>
                            <div className={props.admin || !props.refreshTime ? 'hidden' : "head-refresh-title pull-right"}> Last Refreshed on<br />{props.refreshTime}</div>
                        </div>
                        {props.tblBody}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        printState:state.printState,
        coverLoadingState: state.coverLoadingState,
        notificationState:state.notificationState
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        printProgress:actions.printProgressAction,
        fetchDataToPrint:actions.fetchDataToPrintAction
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTab);
